var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.4eb322c823854b38aafa04a9885d0ae1.svg#f';
                    var viewUrl = 'sprites.4eb322c823854b38aafa04a9885d0ae1.svg#view-f';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 13 12',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };